var map = {
	"./alfonsogomez.png": 40,
	"./aliachakermangeat.png": 41,
	"./christinakitsos.png": 42,
	"./christoivanov.png": 43,
	"./danielsormanni.png": 44,
	"./frederiqueperler.png": 45,
	"./lucbarthassat.png": 46,
	"./mariaperez.png": 47,
	"./mariebarbey.png": 48,
	"./pascalaltenbach.png": 49,
	"./pascalspuhler.png": 50,
	"./pierrebayenet.png": 51,
	"./samikanaan.png": 52,
	"./sanjaduvnjak.png": 53,
	"./simonbrandt.png": 54,
	"./susanneamsler.png": 55
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;